import FieldValidator from 'validator'

/* ex:
	validate: 'isEmail',
	item: {
		value: 'somwhere@here.nowhere',
		errorMessage: 'Invalid Email'
	}
 */
const hasError = (value, item) => {
    let valid
    let defaultMessage = 'Invalid Field'
    const { validator, message } = item

    switch (validator) {
        case 'isRequired':
            valid = !FieldValidator.isEmpty(value)
            defaultMessage = 'Required Field'
            break
        case 'isEmail':
            valid = FieldValidator[validator](value)
            defaultMessage = 'Invalid Email Address Format'
            break
        default:
            valid = FieldValidator[validator](value)
            break
    }

    return valid ? false : message || defaultMessage
}

/* ex:
	value: 'somwhere@here.nowhere',
	validations: [{
			validator: "isRequired"
		},{ 
			validator: "isEmail",
			message: "Invalid Email Address Format (xxx@xxx.xxx)"
	}],
 */
const checkErrors = (value, validations) => {
    return validations.reduce((error, item) => {
        return error || hasError(value, item)
    }, false)
}

const Validator = {
    checkErrors,
}

export default Validator
